"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRatesByState = void 0;
function filterRatesByState(rates, state) {
    return rates.filter(rate => rate.state === state);
}
exports.filterRatesByState = filterRatesByState;
//# sourceMappingURL=state-filterer.js.map